import { createSelector } from 'reselect';
import { keyBy, orderBy } from 'lodash';
import EntriesService from '../../api/services/entriesService';
import CommentsService from '../../api/services/commentsService';
import LikesService from '../../api/services/likesService';
import { reject } from 'lodash';

const LOAD_STREAM_REQUEST = 'dailymile/stream/LOAD_STREAM';
const LOAD_STREAM_SUCCESS = 'dailymile/stream/LOAD_STREAM_SUCCESS';
const LOAD_STREAM_FAIL = 'dailymile/stream/LOAD_STREAM_FAIL';
const LOAD_STREAM_PREVIOUS_REQUEST = 'dailymile/stream/LOAD_STREAM_PREVIOUS';
const LOAD_STREAM_PREVIOUS_SUCCESS = 'dailymile/stream/LOAD_STREAM_PREVIOUS_SUCCESS';
const LOAD_STREAM_PREVIOUS_FAIL = 'dailymile/stream/LOAD_STREAM_PREVIOUS_FAIL';
const LOAD_STREAM_NEXT_REQUEST = 'dailymile/stream/LOAD_STREAM_NEXT';
const LOAD_STREAM_NEXT_SUCCESS = 'dailymile/stream/LOAD_STREAM_NEXT_SUCCESS';
const LOAD_STREAM_NEXT_FAIL = 'dailymile/stream/LOAD_STREAM_NEXT_FAIL';
const CREATE_COMMENT_REQUEST = 'dailymile/stream/CREATE_COMMENT_REQUEST';
const CREATE_COMMENT_SUCCESS = 'dailymile/stream/CREATE_COMMENT_SUCCESS';
const CREATE_COMMENT_FAIL = 'dailymile/stream/CREATE_COMMENT_FAIL';
const CREATE_LIKE_REQUEST = 'dailymile/stream/CREATE_LIKE_REQUEST';
const CREATE_LIKE_SUCCESS = 'dailymile/stream/CREATE_LIKE_SUCCESS';
const CREATE_LIKE_FAIL = 'dailymile/stream/CREATE_LIKE_FAIL';
const DELETE_LIKE_REQUEST = 'dailymile/stream/DELETE_LIKE_REQUEST';
const DELETE_LIKE_SUCCESS = 'dailymile/stream/DELETE_LIKE_SUCCESS';
const DELETE_LIKE_FAIL = 'dailymile/stream/DELETE_LIKE_FAIL';

const initialState = {
  loading: false,
  loaded: false,
  entriesById: {},
  entriesCommentStatusById: {},
  entriesLikeStatusById: {},
  previousUrl: null,
  nextUrl: null,
  loadingPrevious: false,
  loadingNext: false
};

const handlers = {

  [LOAD_STREAM_REQUEST]: (state, action) => {
    return {
      ...state,
      loading: true
    };
  },


  [LOAD_STREAM_PREVIOUS_REQUEST]: (state, action) => {
    return {
      ...state,
      loadingPrevious: true
    };
  },

  [LOAD_STREAM_NEXT_REQUEST]: (state, action) => {
    return {
      ...state,
      loadingNext: true
    };
  },


  [LOAD_STREAM_SUCCESS]: (state, action) => {
    const { pagination, entries } = action.payload.result;
    const entriesById = keyBy(entries, 'id');

    return {
      ...state,
      loading: false,
      loaded: true,
      entriesById: entriesById,
      previousUrl: pagination.streamPreviousUrl,
      nextUrl: pagination.streamNextUrl
    };
  },


  [LOAD_STREAM_PREVIOUS_SUCCESS]: (state, action) => {
    const { pagination, entries } = action.payload.result;
    const previousEntriesById = keyBy(entries, 'id');

    return {
      ...state,
      loadingPrevious: false,
      entriesById: {
        ...state.entriesById,
        ...previousEntriesById
      },
      previousUrl: pagination.streamPreviousUrl
    };
  },

  [LOAD_STREAM_NEXT_SUCCESS]: (state, action) => {
    const { pagination, entries } = action.payload.result;
    const nextEntriesById = keyBy(entries, 'id');

    return {
      ...state,
      loadingNext: false,
      entriesById: { 
        ...state.entriesById,
        ...nextEntriesById 
      },
      nextUrl: pagination.streamNextUrl
    };

  },


  [LOAD_STREAM_FAIL]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error: action.payload.message
    };
  },

  [LOAD_STREAM_PREVIOUS_FAIL]: (state, action) => {
    return {
      ...state,
      loadingPrevious: false
    };
  },

  [LOAD_STREAM_NEXT_FAIL]: (state, action) => {
    return {
      ...state,
      loadingNext: false
    };
  },

  [CREATE_COMMENT_REQUEST]: (state, action) => {
    return {
      ...state,
      entriesCommentStatusById: {
        ...state.entriesCommentStatusById,
        [action.payload.entryId]: 'loading'
      }
    };
  },


  [CREATE_COMMENT_SUCCESS]: (state, action) => {
    const entryId = action.payload.entryId;
    const entryToUpdate = state.entriesById[entryId];
    const updatedEntry = entryToUpdate.setIn(['comments'], entryToUpdate.comments.concat(action.payload.result));

    return {
      ...state,
      entriesById: {
          ...state.entriesById,
          [entryId]: updatedEntry
      },
      entriesCommentStatusById: {
        ...state.entriesCommentStatusById,
        [entryId]: null
      }
    };
  },

  [CREATE_COMMENT_FAIL]: (state, action) => {
    const entryId = action.payload.entryId;

    return {
      ...state,
      entriesCommentStatusById: {
        ...state.entriesCommentStatusById,
        [entryId]: null
      }
    };
  },

  [CREATE_LIKE_REQUEST]: (state, action) => {
    const entryId = action.payload.entryId;

    return {
      ...state,
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: 'liking'
      }
    };
  },

  [CREATE_LIKE_SUCCESS]: (state, action) => {
    const entryId = action.payload.entryId;
    const entryToUpdate = state.entriesById[entryId];
    const updatedEntry = entryToUpdate.setIn(['likes'], entryToUpdate.likes.concat(action.payload.result));

    return {
      ...state,
      entriesById: {
          ...state.entriesById,
          [entryId]: updatedEntry
      },
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: null
      }
    };
  },

  [CREATE_LIKE_FAIL]: (state, action) => {
    const entryId = action.payload.entryId;

    return {
      ...state,
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: null
      }
    };
  },

  [DELETE_LIKE_REQUEST]: (state, action) => {
    const entryId = action.payload.entryId;

    return {
      ...state,
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: 'unliking'
      }
    };
  },

  [DELETE_LIKE_SUCCESS]: (state, action) => {
    const entryId = action.payload.entryId;
    const entryToUpdate = state.entriesById[entryId];
    const updatedEntry = entryToUpdate.setIn(['likes'], reject(entryToUpdate.likes, like => like.id === action.payload.result.id));

    return {
      ...state,
      entriesById: {
          ...state.entriesById,
          [entryId]: updatedEntry
      },
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: null
      }
    };
  },

  [DELETE_LIKE_FAIL]: (state, action) => {
    const entryId = action.payload.entryId;

    return {
      ...state,
      entriesLikeStatusById: {
        ...state.entriesLikeStatusById,
        [entryId]: null
      }
    };
  }
};

export default function reducer(state = initialState, action = {}) {
  if (handlers[action.type]) {
    return handlers[action.type](state, action);
  }
  return state;
}

const byIdSelector = state => state.stream.entriesById;

export const homeStreamEntriesSelector = createSelector(
  byIdSelector,
  (entriesById) => orderBy(Object.values(entriesById), 'createdAt', 'desc')
);

export function createComment(entry, newCommentText) {
  return {
    description: 'create comment',
    types: [CREATE_COMMENT_REQUEST, CREATE_COMMENT_SUCCESS, CREATE_COMMENT_FAIL],
    promise: () => CommentsService.createComment(entry, newCommentText),
    entryId: entry.id
  }
}

export function createLike(entry, likeType) {
  return {
    description: 'create like',
    types: [CREATE_LIKE_REQUEST, CREATE_LIKE_SUCCESS, CREATE_LIKE_FAIL],
    promise: () => LikesService.createLike(entry, likeType),
    entryId: entry.id
  }
}

export function destroyLike(entry, like) {
  return {
    description: 'delete like',
    types: [DELETE_LIKE_REQUEST, DELETE_LIKE_SUCCESS, DELETE_LIKE_FAIL],
    promise: () => LikesService.destroyLike(like),
    entryId: entry.id
  }
}

export function loadCurrentUserStream(currentUser) {
  return {
    description: 'fetch stream',
    types: [LOAD_STREAM_REQUEST, LOAD_STREAM_SUCCESS, LOAD_STREAM_FAIL],
    promise: () => EntriesService.getStreamForCurrentUser(currentUser)
  };
}

export function loadStreamPrevious() {
  return {
    description: 'fetch previous entries',
    types: [LOAD_STREAM_PREVIOUS_REQUEST, LOAD_STREAM_PREVIOUS_SUCCESS, LOAD_STREAM_PREVIOUS_FAIL],
    promise: getState => {
      const url = getState().stream.previousUrl;
      return EntriesService.fetchStreamFromUrl(url);
    }
  };
}

export function loadStreamNext() {
  return {
    description: 'fetch next entries',
    types: [LOAD_STREAM_NEXT_REQUEST, LOAD_STREAM_NEXT_SUCCESS, LOAD_STREAM_NEXT_FAIL],
    promise: getState => {
      const url = getState().stream.nextUrl;
      return EntriesService.fetchStreamFromUrl(url);
    }
  };
}


// WEBPACK FOOTER //
// ./src/redux/modules/stream.js